import React from 'react';

import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined';

import classes from './ViewResourceLibrary.module.scss';
import {
  LbTabPanel,
  LbTabs,
  LbToggleTabsList,
  TabsConfig,
} from '../../../../shared/components/tabs';
import { VideoList } from '../../../pages/resource-library/VideoList/VideoList';
import { useVideo } from '../../../pages/resource-library/hooks/useVideo';
import { VideoPageType } from '../../../constants/videoPage';
import { VIDEO_DOCUMENTS } from '../../../constants/videoDocuments';
import { ResourceLibraryPageTitle } from '../ResourceLibraryPageTitle/ResourceLibraryPageTitle';

type ViewResourceLibraryProps = {
  page: VideoPageType;
};

export const ViewResourceLibrary = ({ page }: ViewResourceLibraryProps) => {
  const { videoData } = useVideo(page);

  const tabsConfig: TabsConfig[] = videoData.map((videoCategory, index) => ({
    label: videoCategory.name,
    hide: !videoCategory.videos.length,
    value: index,
    // NEED REFACTOR (LMP-5173): doc links from a hardcoded config, keyed by
    // page -> category name -> rendered video index. See constants/videoDocuments.
    panel: (
      <VideoList
        videos={videoCategory.videos}
        docLinks={VIDEO_DOCUMENTS[page]?.[videoCategory.name]}
      />
    ),
    icon: videoCategory.featuredCategory ? <StarBorderOutlinedIcon /> : null,
  }));

  return (
    <>
      <ResourceLibraryPageTitle page={page} />
      <LbTabs defaultValue={0}>
        {tabsConfig.length > 1 && (
          <LbToggleTabsList
            size="small"
            tabsConfig={tabsConfig}
            className={classes.tabList}
          />
        )}
        <LbTabPanel tabsConfig={tabsConfig} />
      </LbTabs>
    </>
  );
};
